'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');let

FatigueTrendsDataService=function(_GroupBasedDataServic){_inherits(FatigueTrendsDataService,_GroupBasedDataServic);_createClass(FatigueTrendsDataService,null,[{key:'$inject',get:function()
{
return['$timeout','statisticalDisplayDataService','timeZoneService','groupTreeService'];
}}]);

function FatigueTrendsDataService($timeout,statisticalDisplayDataService,timeZoneService,groupTreeService){_classCallCheck(this,FatigueTrendsDataService);var _this=_possibleConstructorReturn(this,
_GroupBasedDataServic.call(this,$timeout,groupTreeService));
_this._statisticalDisplayDataService=statisticalDisplayDataService;
_this._localTimeZone=timeZoneService.localTimeZone;

_this._displayInterval=void 0;return _this;
}FatigueTrendsDataService.prototype.









_clearPersistentData=function _clearPersistentData(){
_GroupBasedDataServic.prototype._clearPersistentData.call(this);
this._displayInterval=void 0;
};FatigueTrendsDataService.prototype.

_update=function(){var ref=_asyncToGenerator(function*(cancellationToken){
const statisticsRequest={
calendarRange:CalendarRange.fromTimeInterval(this._displayInterval,this._localTimeZone),
requestedOrgStats:[
'averageFatigueOnDuty',
'maxFatigueOnDuty'],

requestedGroupStats:[
'averageFatigueOnDuty',
'maxFatigueOnDuty'],

requestedPersonalStats:[
'fatigueDistribution',
'dutyHours',
'maxFatigueOnDuty',
'averageFatigueOnDuty']};



if(this._fatigueMeterType===FatigueMeterType.Trucking){
_.pushMany(statisticsRequest.requestedPersonalStats,['numTripsOnDuty']);
}

if(this._fatigueMeterType===FatigueMeterType.Workforce){
_.pushMany(statisticsRequest.requestedPersonalStats,['numDuties']);
}

const fleetInsightData=yield this._statisticalDisplayDataService.fetchFatigueTrendsDataFor(statisticsRequest);

if(cancellationToken.cancelled){
return;
}

this.groupTree=fleetInsightData.groupTree;
});function _update(cancellationToken){return ref.apply(this,arguments)}return _update}();_createClass(FatigueTrendsDataService,[{key:'displayInterval',get:function(){return this._displayInterval},set:function(displayInterval){this._displayInterval=displayInterval}}]);return FatigueTrendsDataService}(GroupBasedDataService);


module.exports=FatigueTrendsDataService;
//# sourceMappingURL=fatigueTrendsDataService.js.map
